<!-- Revised on 2024/12/11 by mnavarro -->
<template>
    <div class="pb-0 card-header">
        <div class="d-lg-flex gap-2">
            <div>
                <h5 class="mb-0">{{ title }}</h5>
                <p class="mb-0 text-sm">{{ description }}</p>
            </div>
            <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto mt-2 gap-2 d-flex flex-wrap">
                    <!-- Edit actions (Add, clone and edit) -->
                    
                    <!-- Activate and deactivate actions -->
                    
                    <!-- Recover and delete actions -->
                    
                    <!-- Interactions with database (filters and reload) -->
                    <ImportStatusFilter id="importStatusFilter" :filter-status-selected="listFilters?.status" @import-status-filter-change="importStatusFilterChange"/>
                    <ClearAllFiltersButton id="clearAllFiltersButton" :enable-clear-all-filters="checkActiveFilters()" @clear-all-filters="clearAllFilters"/>
                    <ReloadButton id="reload" :enable-reload="enableReload" @reload-page="reloadPage"/>
                </div>
            </div>
            <div class="mt-4 mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                    <!-- Search space -->
                    <Searchbox id="searchbox" :enable-search="enableSearch" :filter-search="listFilters?.search" @search-change="searchChange"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import ClearAllFiltersButton from "./../../../../generic_components/ClearAllFiltersButton.vue";
    import ImportStatusFilter from "./../filters/ImportStatusFilter.vue";
    import ReloadButton from "./../../../../generic_components/ReloadButton.vue";
    import Searchbox from "./../../../../generic_components/Searchbox.vue";

    export default {
        name: "ImportListTableHeader",
        components: {
            ClearAllFiltersButton,
            ImportStatusFilter,
            ReloadButton,
            Searchbox
        },
        props: {
            title: {
                type: String,
                default: ""
            },
            description: {
                type: String,
                default: ""
            },
            enableReload: {
                type: Boolean,
                default: true
            },
            enableSearch: {
                type: Boolean,
                default: true
            },
            selectedIds: {
                type: Array,
                default: () => []
            },
            listFilters: {
                type: Object,
                default: () => ({})
            }
        },
        emits: ['clear-all-filters', 'search-change', 'reload-page', 'import-status-filter-change'],
        methods: {
            checkActiveFilters() {
                return this.listFilters?.status !== '' || this.listFilters?.search !== '';
            },
            clearAllFilters() {
                this.$emit("clear-all-filters");
            },
            importStatusFilterChange(status) {
                this.$emit("import-status-filter-change", status);
            },
            reloadPage() {
                this.$emit("reload-page");
            },
            searchChange(searchValue) {
                this.$emit("search-change", searchValue);
            }
        }
    }

</script>